import { IonPage, IonSpinner } from '@ionic/react';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { usersAtom } from '../utils/Global';

const Logout: React.FC = () => {
    const setUser = useSetAtom(usersAtom);

    useEffect(() => {
        setTimeout(() => {
            setUser({ mainUser: null });
        }, 1500);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <IonPage id="logout-page">
            <div className="grid h-screen place-items-center">
                <div className="grid place-items-center">
                    <div>Déconnexion en cours</div>
                    <IonSpinner />
                </div>
            </div>
        </IonPage>
    );
};

export default Logout;
